import { SignJWT } from "jose";

// ─────────────────────────────────────────────────────────────────────────
// TEST-ONLY CONFIG — put your Zoom Video SDK credentials here.
// Get them from https://marketplace.zoom.us -> Develop -> Build App -> Video SDK
//
// ⚠️ Shared by every page under src/ZoomConference. The SDK Secret is used
// to sign the join JWT directly in the browser so you can test quickly
// without standing up a backend endpoint first. Fine for local testing, but
// the secret is visible to anyone who opens devtools. Before shipping this
// to real users, move buildZoomSignature() to a server endpoint and stop
// sending the secret to the client.
// ─────────────────────────────────────────────────────────────────────────
export const ZOOM_CONFIG = {
  sdkKey: "omMWeMOIYn157u3OOEpxepb1zg03ydSbUbz4",    // <-- paste your Zoom Video SDK Key here
  sdkSecret: "tF07InEOP1CXHmVohcAF9vAUsX7Ni30OUBzu", // <-- paste your Zoom Video SDK Secret here
};

export const ROLE_HOST = 1;
export const ROLE_PARTICIPANT = 0;

export const SESSION_PARAM = "session";

export const generateSessionName = () =>
  `sess-${Math.random().toString(36).slice(2, 10)}`;

// Builds a shareable link pointing at `pathname` (defaults to the current
// page) carrying the session name so whoever opens it auto-joins as a
// participant in that same session.
export const buildMeetingLink = (sessionName, pathname = window.location.pathname) => {
  const url = new URL(window.location.origin + pathname);
  url.searchParams.set(SESSION_PARAM, sessionName);
  return url.toString();
};

export async function buildZoomSignature({ sdkKey, sdkSecret, sessionName, role }) {
  if (!sdkKey || !sdkSecret) {
    throw new Error("Missing SDK Key/Secret — fill them in above before joining.");
  }
  const iat = Math.floor(Date.now() / 1000) - 30;
  const exp = iat + 60 * 60 * 2; // 2 hour session validity

  const secretBytes = new TextEncoder().encode(sdkSecret);

  return new SignJWT({
    app_key: sdkKey,
    tpc: sessionName,
    role_type: role,
    version: 1,
  })
    .setProtectedHeader({ alg: "HS256", typ: "JWT" })
    .setIssuedAt(iat)
    .setExpirationTime(exp)
    .sign(secretBytes);
}
